class SessionHelper {
  setToken(token) {
    localStorage.setItem("token", JSON.stringify(token));
  }
  getToken() {
    return JSON.parse(localStorage.getItem("token"));
  }
  setUserData(userdata) {
    localStorage.setItem("userData", JSON.stringify(userdata));
  }
  getUserData() {
    return JSON.parse(localStorage.getItem("userData"));
  }
  setUserEmail(value) {
    localStorage.setItem("userEmail", JSON.stringify(value));
  }
  getUserEmail() {
    return JSON.parse(localStorage.getItem("userEmail"));
  }
  setOtp(value) {
    localStorage.setItem("otp", value);
  }
  getOtp() {
    return localStorage.getItem("otp");
  }
  sessionDestroy() {
    localStorage.clear();
    window.location.href = "/login";
  }
}

export const {
  getToken,
  setToken,
  setUserData,
  getUserData,
  getUserEmail,
  setUserEmail,
  getOtp,
  setOtp,
  sessionDestroy,
} = new SessionHelper();
